<template>
    <empty-state
        :title="title"
        :description="description"
        image="email-broadcasts-color"
    >
        <ds-outline-button
            data-qa="create-broadcast-button"
            @click="$emit('new-email')"
        >
            {{ action }}
        </ds-outline-button>
    </empty-state>
</template>

<script>
import EmptyState from '@/components/shared/EmptyState';

export const EMPTY_STATE_TITLE = 'You haven\'t sent any email broadcasts yet';
export const EMPTY_STATE_DESC = 'A broadcast is an email that\'s sent to many contacts at once. After you create and send a broadcast the results will be available here.';
export const EMPTY_ACTION_TEXT = 'Create a broadcast';

export default {
    components: {
        EmptyState,
    },

    data() {
        return {
            title: EMPTY_STATE_TITLE,
            description: EMPTY_STATE_DESC,
            action: EMPTY_ACTION_TEXT,
        };
    },
};
</script>
